var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"juntar__botao-link",attrs:{"id":"botaoJuntar"},on:{"click":function($event){return _vm.$emit('juntarDocumento')}}},[_c('i',{staticClass:"fab fa-telegram-plane",attrs:{"aria-hidden":"true"}}),_vm._v(" Juntar ")])}
var staticRenderFns = []

export { render, staticRenderFns }